<div class="nxe-explorer">
    <div class="nxe-explorer-left">
        <nxe-tree></nxe-tree>
    </div>
    <div class="nxe-explorer-right">
        <nxe-content [showSwitcher]="showSwitcher" [showSendFile]="showSendFile" [showEditFile]="showEditFile"></nxe-content>
    </div>
</div>
